module.exports = require("./ki.d.ts");